<template>
  <div class="device-availability-label"
       :class="classes"
       v-if="someDevicesUnrestricted"
       @click="openDevicesModal">
    <div class="device-availability-label-text">
      {{ text }}
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      childId: {
        type: String,
        required: true
      },

      fullWidth: {
        type: Boolean,
        default: false
      }
    },

    methods: {
      openDevicesModal () {
        if (this.currentUser.hasPaidLicense) {
          this.showModal('devicesAndDeviceStatus', {
            childId: this.child.id
          })
        }
      }
    },

    computed: {
      ...mapGetters('children', {
        getChildById: 'getById'
      }),

      ...mapGetters('auth', {
        currentUser: 'currentUser'
      }),

      child() {
        return this.getChildById(this.childId)
      },

      devices() {
        return this.child.devices
      },

      devicesAmount() {
        return this.devices.length
      },

      unrestrictedDevicesAmount() {
        return this.child.devices.filter(device => device.reason === 'unrestricted').length
      },

      someDevicesUnrestricted() {
        return this.unrestrictedDevicesAmount > 0 &&
          this.unrestrictedDevicesAmount <= this.devicesAmount
      },

      allDevicesUnrestricted() {
        return this.devicesAmount > 0 &&
          this.devicesAmount === this.unrestrictedDevicesAmount
      },

      text () {
        if (this.allDevicesUnrestricted) {
          return this.$t("alerts.NetNannyDisabledOnAllDevices")
        }

        return this.$t("alerts.NetNannyDisabledOnAtLeastOneDevice")
      },

      classes() {
        return {
          'device-availability-label-alert': !this.allDevicesUnrestricted && this.someDevicesUnrestricted,
          'device-availability-label-danger': this.allDevicesUnrestricted,
          'device-availability-label-full-width': this.fullWidth
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .device-availability-label {
    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 6px;
    cursor: pointer;

    &-text {
      font-style: normal;
      font-weight: bold;
      font-size: 8px;
      line-height: 14px;
      letter-spacing: 0.9px;
      text-transform: uppercase;
    }

    &-alert {
      height: 16px;
      width: 100%;

      background: #F7C716;

      &:hover {
        background: color.adjust(#F35D5D, $lightness: -10%);
      }
    }

    &-danger {
      height: 16px;
      width: 100%;

      background: #F35D5D;

      &:hover {
        background: color.adjust(#F35D5D, $lightness: -10%);
      }
    }

    &-full-width {
      width: 100%;
    }
  }
</style>
